import React from 'react';
import HelloAppH5Page from '../hello-app-h5/common/HelloAppH5Page';

const HelloBuyerAppH5Page: React.FC = () => (
  <HelloAppH5Page
    role="buyer"
    documentTitle="打开圆领"
    buttonLabel="打开圆领"
    backgroundImageUrl={`${process.env.PUBLIC_URL}/buyer_h5_bg.jpg`}
    placeholderBackgroundColor="#12B362"
    buttonBackgroundColor="#ffffff"
    buttonTextColor="#1a1a1a"
  />
);

export default HelloBuyerAppH5Page;
